'use strict'

/** マトリクスの凡例（不要・未設定・設定済 / 必須・任意 / 未使用）。完全に静的なため React.memo で 1 度だけ描画する。 */

import React from 'react'

/** @returns {JSX.Element} */
function MatrixLegend() {
  return (
    <div className="legend flex flex-wrap gap-x-4 gap-y-2 px-5 py-2 text-[11px] text-gray-600">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="matrix-legend-chip matrix-legend-chip--bg-white">
          <span className="matrix-legend-chip-dot matrix-legend-chip-dot--gray" />
          不要
        </span>
        <span className="matrix-legend-chip matrix-legend-chip--bg-white">
          <span className="matrix-legend-chip-dot matrix-legend-chip-dot--red" />
          未設定
        </span>
        <span className="matrix-legend-chip matrix-legend-chip--bg-white">
          <span className="matrix-legend-chip-dot matrix-legend-chip-dot--green" />
          設定済
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="matrix-legend-chip matrix-legend-chip--bg-required">
          <span className="matrix-legend-chip-dot matrix-legend-chip-dot--gray" />
          必須・不要
        </span>
        <span className="matrix-legend-chip matrix-legend-chip--bg-required">
          <span className="matrix-legend-chip-dot matrix-legend-chip-dot--red" />
          必須・未設定
        </span>
        <span className="matrix-legend-chip matrix-legend-chip--bg-set">
          <span className="matrix-legend-chip-dot matrix-legend-chip-dot--green" />
          必須・設定済
        </span>
        <span className="matrix-legend-chip matrix-legend-chip--bg-white">
          <span className="matrix-legend-chip-icon">－</span>
          未使用
        </span>
      </div>
    </div>
  )
}

export default React.memo(MatrixLegend)
